// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({root:{widgetLabel:"Legend",points:"Points",lines:"Lines",polygons:"Polygons",creatingLegend:"Creating legend",noLegend:"No legend",dotValue:"1 Dot = {value} {unit}",currentObservations:"Current observations",previousObservations:"Previous observations",high:"High",low:"Low",esriMetersPerSecond:"m/s",esriKilometersPerHour:"km/h",esriKnots:"knots",esriFeetPerSecond:"ft/sec",esriMilesPerHour:"mph",showNormField:"{field} divided by {normField}",showNormPct:"{field} as a percent of the total",showRatio:"Ratio of {field} to {normField}",showRatioPercent:"{field} as a percent of {normField}",showRatioPercentTotal:"{field} as a percent of {field} and {normField}",band0:"band_0",band1:"band_1",band2:"band_2",red:"Red",green:"Green",blue:"Blue"},ar:1,bs:1,ca:1,cs:1,da:1,de:1,el:1,es:1,et:1,fi:1,fr:1,he:1,hi:1,hr:1,hu:1,id:1,it:1,ja:1,ko:1,lv:1,lt:1,nl:1,nb:1,pl:1,"pt-br":1,"pt-pt":1,ro:1,ru:1,sl:1,sr:1,sv:1,th:1,tr:1,uk:1,vi:1,"zh-cn":1,"zh-hk":1,"zh-tw":1});